<template>
    <div>
        <h5>{{ label('Debrief') }} List</h5>
        <!-- Search Criteria Section Start -->
        <debrief-criteria />
        <!-- Search Criteria Section End -->

        <!-- Debrief List Section Start -->
        <debriefs-table />
        <!-- Debrief List Section End -->
    </div>
</template>

<script setup>
import DebriefCriteria from '../modules/DebriefCriteria.vue';
import DebriefsTable from '../modules/DebriefsTable.vue';
import { useLabels } from '@/composables/LabelComposable';

const { label } = useLabels();
</script>
